import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='business-services'
      headingText={<>Ready to take the <WidowBlock>next step&#63;</WidowBlock></>}
      text='Our financial advisors can help you plan and manage your business with products and services that work with your financial plan.'
    />
  );
};
